import Icon from "./Icon";
import './Icon.scss';

export default Icon